import React, { Component } from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Grid,
    FormLabel,
    Box
} from '@mui/material';
import InputTextField from '../../Component/Reusables/InputTextField';


import PartnerServices from '../../Services/PartnerService';
import { ShowAlert } from "../../Component/ShowAlert";
import { loadFromLocalStorage } from '../../Common/Validation/LocalStorage';


// Interface for props
interface AddPayoutPartnerProps {
    open: boolean;
    onClose: (state: boolean, action: string) => void;
    accessToken: string;
    refreshData: () => void;
}

interface AddPayoutPartnerState {
    partnerName: string;
    partnerNameError: string;
    loading: boolean;
    accessToken: string;
}

class AddPayoutPartner extends Component<AddPayoutPartnerProps, AddPayoutPartnerState> {
    constructor(props: AddPayoutPartnerProps) {
        super(props);
        this.state = {
            partnerName: "",
            partnerNameError: "",
            loading: false,
            accessToken: ""
        };
    }

    // Get access token and fetch from currencies
    async componentDidMount() {
        const accesstoken_ = await loadFromLocalStorage('accessToken');

        if (accesstoken_) {
            this.setState({
                accessToken: accesstoken_.toString()
            });
        } else {
            localStorage.clear();
            window.location.href = '/';
        }
    }

    handleChange = (field: keyof AddPayoutPartnerState, value: string) => {
        this.setState({ [field]: value } as unknown as Pick<AddPayoutPartnerState, keyof AddPayoutPartnerState>);
    };

    validateFields = (): boolean => {
        let isValid = true;
        const { partnerName } = this.state;

        if (!partnerName.trim()) {
            this.setState({ partnerNameError: 'Payout Partner Name is required.' });
            isValid = false;
        } else {
            this.setState({ partnerNameError: '' });
        }

        return isValid;
    };

    // Method on save button click api call...
    private handleDialogAction = async (action: string) => {
        if (action === "ok") {
            if (!this.validateFields()) {
                return;
            }

            const postData = {
                partnerName: this.state.partnerName,
            }
            try {
                const response = await PartnerServices.createPayOutPartner(this.state.accessToken, postData);
                if (response.ok) {
                    console.log("Data to be sent:", postData);
                    this.props.onClose?.(true, action);
                    ShowAlert(
                        "Success",
                        "Payout Partner saved successfully!.",
                        "success"
                    ).then(() => {
                        this.props.refreshData();
                    });
                }
            } catch (error) {
                console.error("Error saving Payout Partner:", error);
                ShowAlert("Error", "Failed to save Payout Partner", "error");
            }
        } else this.props.onClose?.(false, action);
    };

    render() {
        const { open, onClose } = this.props;
        const { partnerName, partnerNameError, loading } = this.state;

        return (
            <Dialog
                open={open}
                onClose={() => onClose(false, 'cancel')}
                fullWidth
                maxWidth="sm"
                keepMounted
            >
                <DialogTitle>Add Payout Partner</DialogTitle>
                <DialogContent>
                    <Box display="flex" flexDirection="column" gap={2}>
                        <Grid container spacing={2}>
                            <Grid item xs={12}>
                                <FormLabel className="input-field-label">Payout Name</FormLabel>
                                <InputTextField
                                    placeholder="Enter partner name"
                                    value={partnerName}
                                    inputType="text"
                                    onChange={(value: string) => this.handleChange('partnerName', value)}
                                    error={!!partnerNameError}
                                    helperText={partnerNameError}
                                    disabled={loading}
                                />
                            </Grid>
                        </Grid>
                    </Box>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => this.handleDialogAction("cancel")} disabled={loading}>
                        Cancel
                    </Button>
                    <Button color="secondary" variant="contained" onClick={() => this.handleDialogAction("ok")}>
                        Save
                    </Button>
                </DialogActions>
            </Dialog>
        );
    }
}

export default AddPayoutPartner;
